import React from 'react';
import userOne from '../../assets/img/feed-imgs/center/story/story-user1.png';
import camera from '../../assets/img/feed-imgs/center/modal/camera.svg';
import tvIcon from '../../assets/img/feed-imgs/center/modal/live-tv.svg';
import emoji from '../../assets/img/feed-imgs/center/modal/emoji.svg';

const CreatePost = () => {
    return (
       <div>
            <div className="row mb-3">
                <div className="col-12 d-flex justify-content-center align-items-center">
                    <img className="me-3" src={userOne} style={{width: "55px",borderRadius: "15px" }} alt="" /><button className="custm-pill-button text-start w-100 rounded-pill px-3 modal_btn" type="button">What would you like to share?</button>
                </div>
            </div>
            <div className="row justify-content-end align-items-center mb-3">
                <div className="col-5 col-lg-4 ps-lg-5 d-flex justify-content-between">
                    <img src={camera} alt="" />
                    <img src={tvIcon} alt="" />
                    <img src={emoji} alt="" /></div>
                <div className="col-7 text-end"><button className="custm-pill-button-small rounded-pill px-5 py-2 post_btn" type="button">Post</button></div>
            </div>
       </div>
    );
};

export default CreatePost;